"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftApprovalsProcessor = void 0;
var SimpleProcessor_1 = require("../common/SimpleProcessor");
var NftApprovalDocumentBuilder_1 = require("./NftApprovalDocumentBuilder");
var NftApprovalsProcessor = /** @class */ (function () {
    function NftApprovalsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new SimpleProcessor_1.SimpleProcessor(this.collectionNameBuilder, NftApprovalDocumentBuilder_1.NftApprovalDocumentBuilder.build);
    }
    NftApprovalsProcessor.prototype.process = function (batch) {
        return this.simpleProcessor.process(batch.nftTokenApprovals, batch);
    };
    return NftApprovalsProcessor;
}());
exports.NftApprovalsProcessor = NftApprovalsProcessor;
//# sourceMappingURL=NftApprovalsProcessor.js.map